import { useParams } from 'react-router'
import GenericDashboardIframe from '../dashboard/GenericDashboardIframe'

/**
 * S22 / CA8 — embeds a proxied service as a same-origin iframe at /{prefix}.
 * The prefix comes from the route param; the iframe `src` is /{prefix} (the proxy redirects to the
 * real service), so the frontend never contacts address:port directly (RN9).
 * Reachable from the dynamic dashboard menu items; access is gated by the route guard
 * (DASHBOARD_CUSTOMIZED).
 */
const MainDashboardProxied = () => {
  const { prefix = '' } = useParams()

  return (
    <GenericDashboardIframe url={'iframe:/' + prefix} kioskMode={false} />
  )
}

export default MainDashboardProxied
